import {createStore} from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {request} from '@/manager/net_manager'
import {ElMessage} from 'element-plus'
import {isUserType} from '@/tools/utils'
import {socketService} from '@/manager/socket_manager'

const store = createStore({
    state() {
        return {
            app_info: null,
            capability_configure: {},

            user: null,
            headers: null,

            world_outlook_array: [],
            world_outlook_info: {},
            world_outlook: null,

            stage: null,
            stage_role: null,
            stage_data: null,

            role_array: null,
            role_info: {},
            selected_role: null,

            map_images: {}
        }
    },
    plugins: [
        createPersistedState({
            storage: window.sessionStorage,
            paths: ['user', 'headers', 'world_outlook'],
        })
    ],
    mutations: {
        update_app_info(state, app_info) {
            state.app_info = app_info
        },
        update_capability_configure(state, capability_configure) {
            state.capability_configure = capability_configure
        },

        update_user(state, user) {
            state.user = user
        },
        delete_user(state) {
            state.user = null
        },

        update_headers(state, headers) {
            state.headers = headers
        },

        update_world_outlook_array(state, wo_array) {
            state.world_outlook_array = wo_array
        },
        update_world_outlook(state, worldOutlook) {
            state.world_outlook = worldOutlook
        },

        update_stage(state, stage) {
            state.stage = stage
        },

        update_stage_role(state, stage_role) {
            state.stage_role = stage_role
        },

        update_stage_data(state, payload) {
            if (!state.stage_data) state.stage_data = {}

            const {key, value} = payload
            state.stage_data[key] = value
        },
        delete_stage_data(state) {
            state.stage_data = null
        },

        update_role_array(state, role_array) {
            state.role_array = role_array
        },

        update_selected_role(state, selected_role) {
            state.selected_role = selected_role
        },

        update_role_info(state, payload) {
            const {role_id, key, value} = payload
            if (!state.role_info[role_id]) {
                state.role_info[role_id] = {}
            }
            state.role_info[role_id][key] = value
            // console.log(`存储${role_id} 的 ${key} 为 ${JSON.stringify(value)}`)
        },
        delete_role_info(state, payload) {
            const {role_id, key} = payload
            if (state.role_info[role_id]) {
                if (key) {
                    delete state.role_info[role_id][key]
                } else {
                    delete state.role_info[role_id]
                }
            }
        },

        update_all_role_info(state, role_info) {
            state.role_info = role_info
        },
        delete_all_role_info(state) {
            state.role_info = {}
        },

        update_wo_info(state, payload) {
            const {wo_id, key, value} = payload
            if (!state.world_outlook_info[wo_id]) {
                state.world_outlook_info[wo_id] = {}
            }
            state.world_outlook_info[wo_id][key] = value
        },
        delete_wo_info(state, payload) {
            const {wo_id, key} = payload
            if (state.world_outlook_info[wo_id]) {
                if (key) {
                    delete state.world_outlook_info[wo_id][key]
                } else {
                    delete state.world_outlook_info[wo_id]
                }
            }
        },

        update_map_images(state, payload) {
            const {imageName, image} = payload
            state.map_images[imageName] = image
        },
    },
    actions: {
        get_roles({commit}) {
            if (isUserType(store.state.user.user_type ?? 4)) {
                request('role/list/', {}, 'GET', store.state.headers).then(response => {
                    // console.log(`store内部更新role_list ${JSON.stringify(response)}`)
                    if (response.code === 0) {
                        if (response.data.length > 0) {
                            commit('update_role_array', response.data)
                            if (store.state.world_outlook === null) {
                                commit('update_world_outlook', response.data[0].world_outlook)
                            }
                        }
                    } else {
                        ElMessage.error({message: response.msg, duration: 1500})
                    }
                })
            }
        },
        get_wo_organizations({commit}) {
            if (store.state.world_outlook) {
                const parameters = {'world_outlook_id': store.state.world_outlook.id, 'is_precis': true}
                request('wo_organizations/organizations/get/', parameters, 'POST').then(response => {
                    // console.log(JSON.stringify(response))

                    if (response.code === 0) {
                        commit('update_wo_info', {
                            wo_id: store.state.world_outlook.id,
                            key: 'organizations',
                            value: response.data
                        })
                    }
                })
            }
        },
        get_wo_qualifications({commit}) {
            if (store.state.world_outlook) {
                const parameters = {'world_outlook_id': store.state.world_outlook.id}
                request('qualification/get_wo_qualifications/', parameters, 'POST').then(response => {
                    // console.log(JSON.stringify(response))

                    if (response.code === 0) {
                        commit('update_wo_info', {
                            wo_id: store.state.world_outlook.id,
                            key: 'qualifications',
                            value: response.data
                        })
                    }
                })
            }
        },
        get_drama_tendency({commit}) {
            // 事实上应该考虑世界观设定，但目前应用全世界观
            if (store.state.world_outlook) {
                request('drama/drama_tendency/list/', {}, 'GET').then(response => {
                    // console.log(JSON.stringify(response))

                    if (response.code === 0) {
                        commit('update_wo_info', {
                            wo_id: store.state.world_outlook.id,
                            key: 'drama_tendency',
                            value: response.data
                        })
                    }
                })
            }
        },
        get_drama_nature({commit}) {
            // 事实上应该考虑世界观设定，但目前应用全世界观
            if (store.state.world_outlook) {
                request('drama/drama_nature/list/', {}, 'GET').then(response => {
                    // console.log(JSON.stringify(response))

                    if (response.code === 0) {
                        commit('update_wo_info', {
                            wo_id: store.state.world_outlook.id,
                            key: 'drama_nature',
                            value: response.data
                        })
                    }
                })
            }
        },
        get_props_types({commit}) {
            // 事实上应该考虑世界观设定，但目前应用全世界观
            if (store.state.world_outlook) {
                request('props/config/get_props_types/', {}, 'GET').then(response => {
                    // console.log(JSON.stringify(response))

                    if (response.code === 0) {
                        commit('update_wo_info', {
                            wo_id: store.state.world_outlook.id,
                            key: 'props_types',
                            value: response.data
                        })
                    }
                })
            }
        },
        get_props_tags({commit}) {
            // 事实上应该考虑世界观设定，但目前应用全世界观
            if (store.state.world_outlook) {
                request('props/config/get_props_tags/', {}, 'GET').then(response => {
                    // console.log(JSON.stringify(response))

                    if (response.code === 0) {
                        commit('update_wo_info', {
                            wo_id: store.state.world_outlook.id,
                            key: 'props_tags',
                            value: response.data
                        })
                    }
                })
            }
        },
        get_capability_types({commit}) {
            // 事实上应该考虑世界观设定，但目前应用全世界观
            if (store.state.world_outlook) {
                request('capabilities/type/list/', {}, 'GET').then(response => {
                    // console.log(JSON.stringify(response))

                    if (response.code === 0) {
                        commit('update_wo_info', {
                            wo_id: store.state.world_outlook.id,
                            key: 'capability_types',
                            value: response.data
                        })
                    }
                })
            }
        },
        get_market_channels({commit}) {
            if (store.state.world_outlook) {
                const parameters = {'world_outlook_id': store.state.world_outlook.id, 'is_precis': true}
                request('market_channel/market_channels/list/', parameters, 'POST').then(response => {
                    // console.log(JSON.stringify(response))

                    if (response.code === 0) {
                        commit('update_wo_info', {
                            wo_id: store.state.world_outlook.id,
                            key: 'market_channels',
                            value: response.data
                        })
                    }
                })
            }
        },
        stage_ws_connect(_, access_token) {
            if (!socketService.socket) {
                socketService.connect(access_token)
            }
        },
        stage_ws_disconnect() {
            if (socketService.socket) {
                socketService.disconnect()
            }
            // if (!store.state.stage || !store.state.stage.stage_id) {
            //     socketService.disconnect()
            // }
        }
    }
})

export default store
